var map = {
	"./carousel/behaviour.js": "EREZ",
	"./country-readmore/behaviour.js": "L1vi",
	"./disclosure-panel/behaviour.js": "fXEr",
	"./header/behaviour.js": "B6LY",
	"./homepage-animation/behaviour.js": "+umo",
	"./score-table/behaviour.js": "MY/T",
	"./share-buttons/behaviour.js": "njiB",
	"./title-bar/behaviour.js": "uKsT",
	"./translate-dropdown/behaviour.js": "e/p3",
	"./wheel-key/behaviour.js": "RVue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hUjg";